/**
 * Extraction-correction capture (EX.9 / Pillar-D D.6).
 *
 * When a PM edits an AI-extracted field in the intake review before saving, we
 * record the {extracted → corrected} pair. Over time this is a labelled eval
 * dataset of where extraction fell short — the ground truth for tuning prompts
 * / response schemas and measuring extraction accuracy. Captured only when the
 * extraction was real (gemini/mixed), never for stub/seed data.
 *
 * Stored as an `extraction.corrected` domain event on the project aggregate
 * (ADR-0012) — no new table; the event log is the audit + eval substrate.
 */
import { z } from 'zod';
import { UuidSchema } from './common.js';
export const ExtractionCorrectionItemSchema = z.object({
    /** Field path on the draft, e.g. "client_name" or "site_address.city". */
    field: z.string().min(1).max(120),
    /** The AI's extracted value, normalized to a string (null when it was empty). */
    extracted_value: z.string().max(4000).nullable(),
    /** What the PM corrected it to (null when they cleared it). */
    corrected_value: z.string().max(4000).nullable(),
});
export const ExtractionCorrectionsInputSchema = z.object({
    project_id: UuidSchema,
    /** Which intake channel produced the draft. */
    channel: z.enum(['pdf_upload', 'chat']),
    /** How the draft was extracted, so eval pairs can be filtered by provenance. */
    extraction_source: z.enum(['gemini', 'mixed']),
    corrections: z.array(ExtractionCorrectionItemSchema).min(1).max(50),
});
export const ExtractionCorrectionsResultSchema = z.object({
    recorded: z.number().int(),
});
//# sourceMappingURL=corrections.js.map